<template>
  <el-dialog
    :modal='false'
    title='视频通话'
    :visible.sync='dialogVisible'
    width='680px'
    :before-close='handleClose'
    :append-to-body='true'
  >
    <div
      id='remoteplayer'
      style='
                width: 580px;
                height: 320px;
                background: #000;
                margin: 0 auto;
                margin-bottom: 10px;
            '
    ></div>
    <div
      id='localplayer'
      style='
                width: 580px;
                height: 320px;
                background: #000;
                margin: 0 auto;
                margin-bottom: 10px;
            '
    ></div>
    <el-button type='primary' @click='init()' style='margin-left: 205px'
    >开始通话
    </el-button
    >
    <el-button type='danger' @click='end()'>结束通话</el-button>
  </el-dialog>
</template>

<script>
// 引入单个模块
// import * as QNRTC from "pili-rtc-web";
// const myRTC = new QNRTC.QNRTCSession();
//const QNRTC = window.QNRTC;
//window.QNRTC = undefined;
const myRTC = new QNRTC.StreamModeSession()
import { post } from '@/api/requrestHttp'

export default {
  props: {
    userId: [String, Number],
    mobilePhone: [String, Number]
  },
  data() {
    return {
      dialogVisible: true,
      roomToken: null
    }
  },
  methods: {
    async play() {
      const stream = await QNRTC.deviceManager.getLocalStream({
        video: { enabled: true },
        audio: { enabled: true }
      })
      // 页面上准备用来播放的元素，就是我们刚刚创建的
      const localVideo = document.getElementById('localplayer')

      // 拿到 stream 对象后，调用 play 就可以播放了
      // sdk 会在指定的元素下创建相应的 video/audio 标签完成播放
      // 这里第二个参数代表用 静音模式 来播放，本地预览的时候一般我们会设置成静音
      stream.play(localVideo, true)

      // 发布自己本地的流
      try {
        myRTC.publish(stream)
        console.log('publish success!')
        await this.subscribe()
      } catch (e) {
        console.log('publish error!', e)
      }
    },

    // myRTC 为加入房间后的 QNRTCSession 实例
    // user 代表加入房间返回或者事件返回的单个用户对象
    subscribeUser(myRTC, user) {
      console.log('subscribeUser begin')
      // 如果用户没有发布就直接返回
      if (!user.published) {
        console.log('用户没有发布就直接返回')
        return
      }
      // 根据需要选择是使用 Promise 还是 async/await
      myRTC
        .subscribe(user.userId)
        .then((remoteStream) => {
          console.log('准备播放订阅')
          // 我们在页面上准备用来显示远端媒体流的元素
          const remotePlayer = document.getElementById('remoteplayer')
          // 在我们准备的元素上播放远端媒体流
          console.log('播放订阅')
          remoteStream.play(remotePlayer)
        })
        .catch((e) => {
          console.log('subscribe error!', e)
        })
      console.log('subscribeUser end')
    },
    async joinRoom() {
      myRTC
        .joinRoomWithToken(this.roomToken)
        .then(async (users) => {
          console.log('joinRoom success!')
          console.log('当前房间用户：', users)
          await this.play()
        })
        .catch((e) => {
          console.log('joinRoom Error!', e)
        })
    },
    async init() {
      post('/jjyl/admin/serviceStaffCustomerCenter/info/openQN', {
        userId: this.mobilePhone,
        mobilePhone: this.mobilePhone,
        uid: this.userId
        // uid: this.$store.state.info.id
      }).then(async (res) => {
        this.roomToken = res.content.roomToken
        console.log('后台返回的token:' + res.content.roomToken)
        await this.joinRoom()
      })
    },

    async subscribe() {
      myRTC.on('user-publish', (user) => {
        this.subscribeUser(myRTC, user)
        console.log('订阅用户' + JSON.stringify(user))
      })
    },
    end() {
      // console.log("end 开始");
      console.log(this.roomToken, 'xxxxxxxxxxxxx')
      if (this.roomToken) {
        myRTC.unpublish()
        myRTC.leaveRoom()
        // console.log("end if");
      }

      this.$emit('update:closeSP', false)
      // console.log("end 结束");
    },
    handleClose() {
      // console.log("handleClose 开始");
      if (this.roomToken) {
        myRTC.unpublish()
        myRTC.leaveRoom()
        // console.log("handleClose if");
      }
      this.$emit('update:closeSP', false)
      // console.log("handleClose 结束");
    }
  },
  mounted() {
    console.log('初始化')
    // console.log("current version is", QNRTC.version);
  }
}
</script>

<style lang='less' scoped>
.m-t10 {
  margin-top: 10px;
}
</style>
